import React, { Fragment, useState } from "react";
import { Form } from "react-bootstrap";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { ERROR_MESSAGES, WEBAPP_MESSAGES } from "src/constants/messages";
import { NOTIFICATION_HEADERS } from "src/constants/notificationHeaders";
import { NOTIFICATION_TYPES } from "src/constants/notificationTypes";
import Api from "src/data/api";
import { fetchUsers } from "src/data/common";
import { showNotification } from "src/redux/notificationActions";
import WebappSettingsFormik from "../Components/WebappSettings/WebappSettingsFormik";
import WebappSettingsFormView from "../Components/WebappSettings/WebappSettingsFormView";

const WEBAPP_SETTINGS_QUERY_KEY = (userId) => ["webapp", "settings", userId];
const USERS_LIST_KEY = ["users", "list"];

const fetchWebappSettings = async (userId) => {
    const { data } = await Api.request({
        url: `/retailer/user/${userId}/webapp-settings`,
    });

    return data.webappSettings;
};

const updateWebappSettings = async (data) => {
    await Api.request({
        method: "PUT",
        url: `/retailer/user/${data.userId}/webapp-settings`,
        data: data.settings,
    });
};

const UsersWebappSettings = () => {
    const user_id = useSelector((store) => store.user.data.user_id);
    const [currentUserId, setCurrentUserId] = useState(user_id);

    const { data: users } = useQuery({
        queryKey: USERS_LIST_KEY,
        queryFn: fetchUsers,
        placeholderData: [],
    });

    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    const { data: webappSettings } = useQuery({
        queryKey: WEBAPP_SETTINGS_QUERY_KEY(currentUserId),
        queryFn: () => fetchWebappSettings(currentUserId),
        placeholderData: {},
    });

    const updateWebappSettingsMutation = useMutation(updateWebappSettings, {
        onSuccess: () => {
            queryClient.invalidateQueries(WEBAPP_SETTINGS_QUERY_KEY(currentUserId));
            dispatch(
                showNotification(
                    WEBAPP_MESSAGES.WEBAPP_SETTINGS_UPDATE_SUCCESS,
                    NOTIFICATION_TYPES.SUCCESS,
                    NOTIFICATION_HEADERS.WEBAPP
                )
            );
        },
        onError: (err, data, context) => {
            dispatch(
                showNotification(
                    ERROR_MESSAGES.SOMETHING_WENT_WRONG,
                    NOTIFICATION_TYPES.ERROR,
                    NOTIFICATION_HEADERS.OOPS
                )
            );
        },
    });

    const handleWebappSettingsUpdate = (values) => {
        updateWebappSettingsMutation.mutate({
            userId: currentUserId,
            settings: values,
        });
    };

    return (
        <Fragment>
            <Form.Group controlId="input-users">
                <Form.Control
                    value={currentUserId}
                    as="select"
                    custom
                    style={{ minWidth: 0, maxWidth: 400 }}
                    onChange={(e) => setCurrentUserId(e.target.value)}
                >
                    {users.map((user) => (
                        <option key={user.user_id} value={user.user_id}>
                            {user.email}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
            <WebappSettingsFormik
                webappSettings={webappSettings}
                updateSettings={handleWebappSettingsUpdate}
            >
                {(props) => <WebappSettingsFormView {...props} />}
            </WebappSettingsFormik>
        </Fragment>
    );
};

export default UsersWebappSettings;
